/** Coloured circle avatar showing the first letter of a name */
interface Props {
  name: string;
  size?: number;
}

const PALETTE = [
  "#1d4fff",
  "#0e7490",
  "#047857",
  "#b45309",
  "#dc2626",
  "#1840d9",
  "#db2777",
  "#0369a1",
];

function colorForName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export function InitialsAvatar({ name, size = 28 }: Props) {
  const bg = colorForName(name);
  const initials = name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: bg,
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.42,
        fontWeight: 700,
        fontFamily: "var(--font-body)",
        flexShrink: 0,
        border: "2px solid var(--color-bg-card)",
        boxSizing: "border-box",
      }}
      title={name}
      aria-label={name}
    >
      {initials}
    </span>
  );
}
